import { Badge, BadgeList } from './Columns'

interface Props {
  badgeIds: number[]
  badgeList: BadgeList
}

const BadgesCell = ({ badgeIds = [], badgeList = [] }: Props) => {
  return (
    <div>
      {(badgeList && badgeIds && badgeList.filter((badge: Badge) => badgeIds.includes(badge.id))
        .map((badge: Badge) => badge.title).join(', '))}
    </div>
  )
}

export default BadgesCell
